import { QuestionCircleOutlined } from "@ant-design/icons";
import "./style.scss";

function ShiftCancellationModalTitle({ title }: { title: string }) {
  return (
    <div className="title-container">
      <QuestionCircleOutlined className="title-question-icon" />
      <span className="title-text">{title}</span>
    </div>
  );
}

export { ShiftCancellationModalTitle };
